import { CheckCircle2, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * UpdateEmployeeResult — shown after actualizar_empleado executes.
 */
export default function UpdateEmployeeResult({ result }) {
  if (!result) return null;
  const cambios = result.cambios ?? [];

  return (
    <div className="rounded-xl border border-success/30 bg-success/10 px-3 py-2.5 flex items-center justify-between gap-3 my-1 max-w-sm">
      <div className="flex items-center gap-2 min-w-0">
        <CheckCircle2 className="w-4 h-4 text-success shrink-0" />
        <div className="min-w-0">
          <p className="text-xs font-semibold text-foreground truncate">
            {result.nombre ?? 'Empleado'} actualizado
          </p>
          <p className="text-[10px] text-muted-foreground">
            {cambios.length} campo{cambios.length !== 1 ? 's' : ''} modificado{cambios.length !== 1 ? 's' : ''}
          </p>
        </div>
      </div>
      {result.employee_id && (
        <Link to={`/employee-detail?id=${result.employee_id}`}>
          <Button size="sm" variant="outline"
            className="h-7 text-[11px] shrink-0 gap-1 border-success/30 text-success hover:bg-success/10">
            Ver
            <ExternalLink className="w-3 h-3" />
          </Button>
        </Link>
      )}
    </div>
  );
}
